var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRainForestActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#fff",
    r: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.4603 11.5271c-1.3078 0-2.3353-1.0275-2.3353-2.33526 0-1.12094 1.6347-3.54964 1.9616-4.01669.1869-.23353.6072-.23353.7473 0 .327.46705 1.9617 2.89575 1.9617 4.01669 0 1.30776-1.0275 2.33526-2.3353 2.33526z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m12.1275 9.17306c0 1.92844 1.54 3.44364 3.5 3.44364.5987 0 1.1582-.1414 1.6467-.3928-.4421.9845-1.4854 1.6777-2.6989 1.6777-.1332 0-.2646-.0085-.3939-.0245l-1.1114 1.6024.5171 3.1275c.0169.1021-.0117.1994-.0805.2742-.0694.0755-.1742.1188-.2874.1188h-1.9245c-.1132 0-.2179-.0432-.2873-.1187-.0688-.0749-.0974-.1722-.0806-.2742l.526-3.181-1.0794-1.5562c-.1469.0208-.2967.0317-.44865.0317-1.6127 0-2.92475-1.2243-2.92475-2.7293 0-.7006.27825-1.35535.7874-1.86189-.26471-.33109-.40865-.73316-.40865-1.14987 0-1.06129.92525-1.92469 2.06247-1.92469.11452 0 .22925.00901.34272.02684.53536-.78225 1.46706-1.26269 2.46606-1.26269.5269 0 1.0217.13069 1.4491.35916-.7754 1.30255-1.5716 2.87158-1.5716 3.8139zm-.6054 4.28834.7578 1.0926.7404-1.0674c-.2934-.172-.5546-.3935-.7703-.6582-.2052.2519-.4517.4648-.7279.633z",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainForestActive);
export default __webpack_public_path__ + "static/media/rain_forest_active.c1cb0f00b09da7b8c99f2c08b86518b7.svg";
export { ForwardRef as ReactComponent };